import React from 'react';
import PropTypes from 'prop-types';
import { LogoCard } from 'src/common/TailwindComponents';
import { InvoiceWorkqueue } from './InvoiceWorkqueue';
import { NoFilteredInvoicesFound } from '../components';
import { ALL_CBO_ADMIN_STATUSES, ALL_NL_STATUSES, ALL_PAYER_STATUSES, INVOICE_WQ_BULK_ACTIONS } from '../constants';

const NoInvoicesExist = () => (
  <>
    <h4 className="font-heavy-font text-base text-dark-grey">
      You don&apos;t have any invoices yet.
    </h4>
    <p className="max-w-xs text-dark-grey">
      Invoices are added to this list whenever a contracted service has been submitted for a client.
    </p>
  </>
);

const AllInvoices = ({ children }) => (
  <InvoiceWorkqueue
    defaultBulkActions={INVOICE_WQ_BULK_ACTIONS.default}
    cboBulkActions={INVOICE_WQ_BULK_ACTIONS.all.cbo}
    networkLeadBulkActions={INVOICE_WQ_BULK_ACTIONS.all.networkLead}
    payerBulkActions={INVOICE_WQ_BULK_ACTIONS.all.payer}
    cboStatuses={ALL_CBO_ADMIN_STATUSES}
    networkLeadStatuses={ALL_NL_STATUSES}
    pageName="All"
    path="all/"
    payerStatuses={ALL_PAYER_STATUSES}
    renderNoInvoicesFound={({ isFiltered, resetFilters }) => (
      <LogoCard>
        {isFiltered ? (
          <NoFilteredInvoicesFound resetFilters={resetFilters} />
          ) : (
            <NoInvoicesExist />
          )}
      </LogoCard>
      )}
    showArchived={null}
    showDisputed={null}
  >
    {children}
  </InvoiceWorkqueue>
  );

AllInvoices.propTypes = {
  children: PropTypes.node,
};

AllInvoices.defaultProps = {
  children: undefined,
};

export default AllInvoices;
